import React from 'react';

export type AdminIconName =
  | 'companies'
  | 'dashboard'
  | 'demoLeads'
  | 'documents'
  | 'licenses'
  | 'requests'
  | 'users'
  | 'warning';

interface AdminIconProps {
  className?: string;
  name: AdminIconName;
}

const icons: Record<AdminIconName, React.ReactNode> = {
  companies: (
    <path d="M2.5 4.5a1 1 0 0 1 1-1H6l1.4 1.6h5.1a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1Z" />
  ),
  dashboard: (
    <>
      <rect x="2.5" y="2.5" width="4.5" height="4.5" rx="1" />
      <rect x="9" y="2.5" width="4.5" height="4.5" rx="1" />
      <rect x="2.5" y="9" width="4.5" height="4.5" rx="1" />
      <rect x="9" y="9" width="4.5" height="4.5" rx="1" />
    </>
  ),
  demoLeads: (
    <>
      <path d="M2.5 4.2h11v8.3h-11z" />
      <path d="m2.8 4.6 5.2 4 5.2-4" />
      <circle cx="12.4" cy="3.2" r="1.6" fill="currentColor" stroke="none" />
    </>
  ),
  documents: (
    <>
      <path d="M4 2.5h5.2l2.8 2.8v8.2H4z" />
      <path d="M9.2 2.8v2.8h2.5M6.2 8h3.7M6.2 10.5h3.7" />
    </>
  ),
  licenses: (
    <>
      <rect x="2.5" y="2.5" width="11" height="11" rx="2.2" />
      <path d="m5.2 8 1.8 1.8L10.8 6" />
    </>
  ),
  requests: (
    <>
      <line x1="4" y1="2.5" x2="4" y2="13.5" />
      <path d="M4 3.2h8L10 6l2 2.8H4" />
    </>
  ),
  users: (
    <>
      <circle cx="8" cy="5.5" r="2.6" />
      <path d="M3 13.5c0-2.6 2.2-4.2 5-4.2s5 1.6 5 4.2" />
    </>
  ),
  warning: (
    <>
      <path d="m8 2.5 6.5 11h-13Z" />
      <line x1="8" y1="6.5" x2="8" y2="9.5" />
      <circle cx="8" cy="11.4" r="0.55" fill="currentColor" stroke="none" />
    </>
  ),
};

const AdminIcon: React.FC<AdminIconProps> = ({ className, name }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    focusable="false"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.7"
    viewBox="0 0 16 16"
  >
    {icons[name]}
  </svg>
);

export default AdminIcon;
